<template>
  <core-view class="flex-column pt-0" fill-height>
    <!-- Botão Novo Fixo no Topo -->
    <div class="divnovo mt-0 elevation-2">
      <v-btn height="45" color="green" class="botaoinferior" @click="$_novoFormulario">
        <v-icon left>mdi-plus</v-icon>
        Novo
      </v-btn>
    </div>

    <div class="wrapper">

      <!-- Indicador de Carregamento -->
      <div v-if="loading" class="text-center my-6">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </div>

      <!-- Lista de Cards -->
      <div v-else class="cards-container">
        <v-card
          v-for="item in itens"
          :key="item.id"
          class="card-embarque"
          elevation="2"
          @click="$_toggleExpand(item.id)"
          ripple
        >
          <!-- Cabeçalho do Card -->
          <div class="card-header">
            <!-- 1ª Linha: ID, Status Sincronização, Placa/Frota e Contrato MP -->
            <div class="d-flex justify-space-between align-center">
              <div class="d-flex align-center flex-wrap min-w-0 mr-2">
                <v-icon
                  small
                  :color="item.sincronizado ? 'green darken-1' : 'amber darken-2'"
                  class="mr-1"
                  :title="item.sincronizado ? 'Sincronizado com a nuvem' : 'Salvo localmente (pendente de envio)'"
                >
                  {{ item.sincronizado ? 'mdi-cloud-check' : 'mdi-cloud-sync-outline' }}
                </v-icon>
                <span class="item-id font-weight-bold mr-2">
                  #{{ item.apeidapontamentoembarque || item.id }}
                </span>
                <span v-if="$_formatarFrotaTitulo(item)" class="frota-titulo font-weight-bold mr-2">
                  {{ $_formatarFrotaTitulo(item) }}
                </span>
              </div>

              <div class="flex-shrink-0 d-flex align-center">
                <v-chip
                  v-if="item.apecontratomp || item.contratoMp"
                  x-small
                  color="blue-grey lighten-5"
                  class="blue-grey--text text--darken-3 font-weight-medium mr-1"
                >
                  Contrato: {{ item.apecontratomp || item.contratoMp }}
                </v-chip>
                <v-icon small color="grey darken-2">
                  {{ $_isExpanded(item.id) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
              </div>
            </div>

            <!-- 2ª Linha: Data e Destino / Produto -->
            <div class="d-flex justify-space-between align-center mt-1">
              <span class="data-texto text-caption grey--text text--darken-1">
                {{ $_formataData(item.apedata || item.dataHora) }}
              </span>

              <!-- <v-chip
                v-if="item.apedestino || item.destino"
                x-small
                color="green lighten-5"
                class="green--text text--darken-3 font-weight-medium"
              >
                <v-icon x-small left color="green darken-2">mdi-map-marker</v-icon>
                {{ item.apedestino || item.destino }}
              </v-chip> -->
            </div>
          </div>

          <!-- Detalhes do Card (Ao expandir) -->
          <v-expand-transition>
            <div v-show="$_isExpanded(item.id)">
              <v-divider></v-divider>
              <div class="card-detalhes" @click.stop>
                <div class="info-row" v-if="item.apemotorista || item.motorista">
                  <span class="info-label">Motorista:</span>
                  <span class="info-valor">{{ item.apemotorista || item.motorista }}</span>
                </div>

                <div class="info-row" v-if="item.apeprodutor || item.produtor">
                  <span class="info-label">Produtor:</span>
                  <span class="info-valor">{{ item.apeprodutor || item.produtor }}</span>
                </div>

                <div class="info-row" v-if="item.apepropriedade || item.propriedade">
                  <span class="info-label">Propriedade:</span>
                  <span class="info-valor">{{ item.apepropriedade || item.propriedade }}</span>
                </div>

                <div class="info-row" v-if="item.produto">
                  <span class="info-label">Produto:</span>
                  <span class="info-valor">{{ item.produto }}</span>
                </div>

                <div class="info-row" v-if="item.apetalhao || item.talhao">
                  <span class="info-label">Talhão:</span>
                  <span class="info-valor">{{ item.apetalhao || item.talhao }}</span>
                </div>

                <div class="info-row" v-if="item.apedestino || item.destino">
                  <span class="info-label">Destino:</span>
                  <span class="info-valor">{{ item.apedestino || item.destino }}</span>
                </div>

                <div class="info-row" v-if="item.apecontratomp || item.contratoMp">
                  <span class="info-label">Contrato MP:</span>
                  <span class="info-valor">{{ item.apecontratomp || item.contratoMp }}</span>
                </div>

                <div class="info-row" v-if="item.apetipomidia || item.tipoMidia">
                  <span class="info-label">Tipo de Mídia:</span>
                  <span class="info-valor text-capitalize">{{ item.apetipomidia || item.tipoMidia }}</span>
                </div>

                <div class="info-row" v-if="item.localizacao || (item.apelatitude && item.apelongitude)">
                  <span class="info-label">Localização GPS:</span>
                  <span class="info-valor d-flex align-center">
                    {{ $_obterCoordenadas(item) }}
                    <!-- <v-btn
                      icon
                      x-small
                      color="primary"
                      class="ml-1"
                      title="Abrir no Google Maps"
                      @click="$_abrirMapa(item)"
                    >
                      <v-icon x-small>mdi-open-in-new</v-icon>
                    </v-btn> -->
                  </span>
                </div>

                <div class="info-row info-obs" v-if="item.apeobservacao || item.observacao">
                  <span class="info-label">Observação:</span>
                  <span class="obs-box">{{ item.apeobservacao || item.observacao }}</span>
                </div>

                <!-- Mídias Anexadas -->
                <div class="fotos-secao mt-2" v-if="item.fotos && item.fotos.length > 0">
                  <div class="d-flex align-center justify-space-between mb-1">
                    <span class="info-label font-weight-bold d-flex align-center">
                      <v-icon small color="grey darken-2" class="mr-1">mdi-camera-outline</v-icon>
                      Mídias Anexadas
                    </span>
                    <v-chip x-small color="grey lighten-2" class="font-weight-medium">
                      {{ item.fotos.length }}
                    </v-chip>
                  </div>
                  <div class="d-flex flex-wrap">
                    <v-card
                      v-for="(foto, fIdx) in item.fotos"
                      :key="fIdx"
                      flat
                      tile
                      class="foto-miniatura-wrapper mr-2 mb-2"
                      @click.stop="$_visualizarFoto(foto)"
                    >
                      <template v-if="foto.tipo === 'video' || foto.blob">
                        <div
                          class="d-flex flex-column align-center justify-center grey darken-3 text-center"
                          style="width: 56px; height: 56px; border-radius: 6px; cursor: pointer;"
                        >
                          <v-icon color="white" small>mdi-play-circle</v-icon>
                          <span class="white--text" style="font-size: 9px !important;">Vídeo</span>
                        </div>
                      </template>
                      <template v-else>
                        <v-img
                          :src="foto.url || foto.src"
                          width="56"
                          height="56"
                          cover
                          style="border-radius: 6px; cursor: pointer; border: 1px solid #cfd8dc;"
                        />
                      </template>
                    </v-card>
                  </div>
                </div>

              </div>
            </div>
          </v-expand-transition>

          <!-- Ações do Card (Excluir, Editar e Enviar) -->
          <v-divider></v-divider>
          <div class="card-acoes d-flex justify-space-between align-center px-3 py-2" @click.stop>
            <div>
              <!-- <v-btn
                icon
                small
                color="red darken-1"
                title="Excluir apontamento"
                @click.stop="$_abrirDialogExcluir(item)"
              >
                <v-icon small>mdi-trash-can-outline</v-icon>
              </v-btn> -->
            </div>

            <div class="d-flex align-center">
              <v-btn
                small
                outlined
                color="primary"
                class="mr-2 text-none font-weight-medium btn-acao"
                @click.stop="$_editar(item)"
              >
                <v-icon left small>mdi-pencil-outline</v-icon>
                Editar
              </v-btn>

              <v-btn
                small
                color="primary"
                class="text-none font-weight-medium btn-acao"
                :loading="enviandoId === (item.idLocal || item.id)"
                :disabled="enviandoId !== null"
                @click.stop="$_enviar(item)"
              >
                <v-icon left small>mdi-cloud-upload-outline</v-icon>
                {{ item.sincronizado ? 'Reenviar' : 'Enviar' }}
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>

    </div>

    <!-- Modal de Confirmação de Exclusão -->
    <v-dialog v-model="dialogExcluir" width="400">
      <v-card>
        <v-card-title class="text-subtitle-1 grey lighten-3 py-3 px-4">
          <span>Excluir Apontamento</span>
          <v-spacer></v-spacer>
          <v-icon color="red darken-1">mdi-alert-outline</v-icon>
        </v-card-title>
        <v-card-text class="pt-4 pb-2">
          Deseja realmente excluir este apontamento de embarque?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3 d-flex justify-end">
          <v-btn text color="grey darken-1" @click="dialogExcluir = false">
            Cancelar
          </v-btn>
          <v-btn color="red darken-1" text @click="$_confirmarExcluir">
            Sim, Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Foto / Vídeo Ampliado -->
    <v-dialog v-model="dialogFotoAmpliada" max-width="600px">
      <v-card v-if="fotoSelecionada">
        <v-card-title class="py-2 px-3 d-flex justify-space-between align-center">
          <span class="text-caption font-weight-bold grey--text text--darken-3">
            {{ fotoSelecionada.nome || 'Visualização da Mídia' }}
          </span>
          <v-btn icon small @click="dialogFotoAmpliada = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-2 text-center">
          <video
            v-if="fotoSelecionada.tipo === 'video' || fotoSelecionada.blob"
            :src="fotoSelecionada.mediaUrl || fotoSelecionada.url || fotoSelecionada.src"
            controls
            style="max-width: 100%; max-height: 75vh;"
            class="mx-auto"
          />
          <v-img
            v-else
            :src="fotoSelecionada.mediaUrl || fotoSelecionada.url || fotoSelecionada.src"
            contain
            max-height="75vh"
            class="mx-auto"
          />
          <div class="text-caption grey--text mt-2" v-if="fotoSelecionada.dataHora">
            Capturada em: {{ fotoSelecionada.dataHora }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </core-view>
</template>

<script>
import moment from 'moment-timezone';
import CoreView from '@/components/core/view/Index.vue';
import db from '@/plugins/dexie';
import {
  APONTAMENTO_EMBARQUE_STORAGE,
  MANUTENCAO_STORAGE,
  ROTA_STORAGE,
} from '@/constants/STORAGE';
import {
  MANUTENCAO_QUERIES,
} from '@/constants/QUERY_FILTERS';
import {
  ROUTE_APONTAMENTO_EMBARQUE_CADASTRO,
} from '@/constants/ROUTES';
import { getQueryValue, setQueryValue } from '@/services/query-string';
import geraData from '@/utils/geradata';
import errorHandler from '@/utils/error-handler';
import { testarConexaoApi } from '@/utils/isonline';
import enviaApontamentoEmbarque, { deletaApontamentoEmbarque } from '@/utils/local/enviaApontamentoEmbarque';
import { getVideoBlob } from '@/utils/local/apontamentoVideoBlobs';

export default {
  name: 'ViewApontamentoEmbarque',

  components: {
    CoreView,
  },

  data() {
    return {
      loading: false,
      enviandoId: null,
      expandedIds: [],
      dialogExcluir: false,
      itemParaExcluir: null,
      dialogFotoAmpliada: false,
      fotoSelecionada: null,

      todosItens: [],
      itens: [],
    };
  },

  computed: {
    temFiltrosAtivos() {
      const hoje = geraData(new Date(), 'YYYY-MM-DD');
      const storageFrom = sessionStorage.getItem(APONTAMENTO_EMBARQUE_STORAGE.createdFrom)
        || sessionStorage.getItem(MANUTENCAO_STORAGE.createdFrom);
      const storageBefore = sessionStorage.getItem(APONTAMENTO_EMBARQUE_STORAGE.createdBefore)
        || sessionStorage.getItem(MANUTENCAO_STORAGE.createdBefore);
      const storagePlaca = sessionStorage.getItem(MANUTENCAO_STORAGE.placa);

      const from = getQueryValue(MANUTENCAO_QUERIES.createdFrom, storageFrom || null);
      const before = getQueryValue(MANUTENCAO_QUERIES.createdBefore, storageBefore || null);
      const placa = getQueryValue(MANUTENCAO_QUERIES.placa, storagePlaca || null);
      const dataDiferenteDeHoje = (from && from !== hoje) || (before && before !== hoje);

      return Boolean(
        dataDiferenteDeHoje
        || (placa && placa !== 'null' && placa !== 'undefined'),
      );
    },
  },

  methods: {
    $_toggleExpand(id) {
      const index = this.expandedIds.indexOf(id);
      if (index > -1) {
        this.expandedIds.splice(index, 1);
      } else {
        this.expandedIds.push(id);
      }
    },

    $_isExpanded(id) {
      return this.expandedIds.includes(id);
    },

    $_formatarFrotaTitulo(item) {
      if (!item) return '';

      const sanitize = (val) => {
        if (val == null) return '';
        const str = String(val).trim();
        const lower = str.toLowerCase();
        if (lower === 'veículo' || lower === 'veiculo' || lower === 'frota não informada' || lower === '-') {
          return '';
        }
        return str;
      };

      const vei = item.veiculo || {};
      let frota = sanitize(item.veifrota) || sanitize(vei && vei.veifrota) || sanitize(item.frota);
      const placa = sanitize(item.apeplaca) || sanitize(item.veiplaca) || sanitize(vei && vei.veiplaca) || sanitize(item.placa);
      const marca = sanitize(item.veimarca) || sanitize(vei && vei.veimarca) || sanitize(item.marca);

      if (frota && marca && frota.toLowerCase() === marca.toLowerCase()) {
        frota = '';
      }

      const partes = [];
      if (frota) partes.push(frota);
      if (placa) partes.push(placa);
      if (marca) partes.push(marca);

      if (partes.length === 0) {
        const desc = sanitize(vei && vei.veidescricao) || sanitize(item.veidescricao);
        return desc || '';
      }

      return partes.join(' - ');
    },

    $_formataData(data) {
      if (!data) return '';
      return moment.tz(data, 'America/Sao_Paulo').local().format('DD/MM/YYYY HH:mm');
    },

    $_obterCoordenadas(item) {
      if (!item) return '';
      const lat = item.apelatitude ?? item.localizacao?.latitude;
      const lng = item.apelongitude ?? item.localizacao?.longitude;
      if (lat == null || lng == null) return '';
      return `${lat}, ${lng}`;
    },

    $_abrirMapa(item) {
      const lat = item.apelatitude ?? item.localizacao?.latitude;
      const lng = item.apelongitude ?? item.localizacao?.longitude;
      if (lat != null && lng != null) {
        window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`, '_blank');
      }
    },

    $_obterMidiaUrl(foto) {
      if (!foto) return '';
      const blob = foto.blob || getVideoBlob(foto.id);
      if (blob instanceof Blob) {
        return URL.createObjectURL(blob);
      }
      return foto.url || foto.src || '';
    },

    $_visualizarFoto(foto) {
      this.fotoSelecionada = {
        ...foto,
        mediaUrl: this.$_obterMidiaUrl(foto),
      };
      this.dialogFotoAmpliada = true;
    },

    $_novoFormulario() {
      sessionStorage.setItem(ROTA_STORAGE.cadastro, 'apontamentoEmbarque');
      sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.formulario);
      sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.itemSelecionado);
      sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.campoSelecao);
      sessionStorage.removeItem('APONTAMENTO_EMBARQUE_SNAPSHOT');
      this.$router.push({
        name: ROUTE_APONTAMENTO_EMBARQUE_CADASTRO.name,
      });
    },

    $_editar(item) {
      sessionStorage.setItem(ROTA_STORAGE.cadastro, 'apontamentoEmbarque');
      sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.formulario);
      sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.itemSelecionado);
      sessionStorage.removeItem(APONTAMENTO_EMBARQUE_STORAGE.campoSelecao);
      sessionStorage.removeItem('APONTAMENTO_EMBARQUE_SNAPSHOT');
      this.$router.push({
        name: ROUTE_APONTAMENTO_EMBARQUE_CADASTRO.name,
        query: { id: item.idLocal || item.id },
      });
    },

    $_abrirDialogExcluir(item) {
      this.itemParaExcluir = item;
      this.dialogExcluir = true;
    },

    async $_confirmarExcluir() {
      if (!this.itemParaExcluir) return;
      const idExcluir = this.itemParaExcluir.idLocal || this.itemParaExcluir.id;
      this.dialogExcluir = false;

      try {
        if (db.apontamentoembarque) {
          const reg = await db.apontamentoembarque.get(Number(idExcluir) || idExcluir);
          if (reg && (reg.apeidapontamentonuvem || reg.apeidnuvem)) {
            await db.apontamentoembarque.update(reg.id, {
              apedeletar: 1,
              deletar: 1,
              apedataalteracao: geraData(),
            });
          } else {
            await db.apontamentoembarque.delete(Number(idExcluir) || idExcluir);
          }
        }

        try {
          const chaveLs = 'APONTAMENTOS_EMBARQUE_LISTA';
          const listaAtual = JSON.parse(localStorage.getItem(chaveLs) || '[]');
          const novaLista = listaAtual.filter((i) => String(i.id) !== String(idExcluir));
          localStorage.setItem(chaveLs, JSON.stringify(novaLista));
        } catch (lsErr) {
          // ignore
        }

        // Tenta sincronizar a exclusão com a nuvem se tiver conexão
        try {
          deletaApontamentoEmbarque().catch(() => {});
        } catch (syncErr) {
          // ignore
        }

        errorHandler('Apontamento de embarque excluído com sucesso.');
        await this.$_load();
      } catch (err) {
        console.error('Erro ao excluir apontamento de embarque:', err);
        errorHandler('Erro ao excluir apontamento de embarque.');
      } finally {
        this.itemParaExcluir = null;
      }
    },

    async $_enviar(item) {
      const idLocal = item.idLocal || item.id;
      if (!idLocal) {
        errorHandler('Erro: ID local não encontrado para envio.');
        return;
      }

      this.enviandoId = idLocal;
      try {
        const conectou = await testarConexaoApi();
        if (!conectou) {
          errorHandler('Sem conexão com o servidor. O apontamento será sincronizado quando estiver online.');
          return;
        }

        await enviaApontamentoEmbarque(idLocal);

        let itemAtualizado = await db.apontamentoembarque.get(Number(idLocal) || idLocal);
        if (!itemAtualizado && !Number.isNaN(Number(idLocal))) {
          itemAtualizado = await db.apontamentoembarque.get(idLocal);
        }
        if (!itemAtualizado) {
          itemAtualizado = await db.apontamentoembarque.where('apeidapontamentoembarque').equals(Number(idLocal) || idLocal).first();
        }

        if (itemAtualizado && (itemAtualizado.apeenviado || itemAtualizado.enviado || itemAtualizado.apedatanuvem || itemAtualizado.apeidnuvem || itemAtualizado.apeidapontamentonuvem)) {
          await db.apontamentoembarque.update(itemAtualizado.id, {
            apeenviado: 1,
            enviado: 1,
          });

          try {
            const chaveLs = 'APONTAMENTOS_EMBARQUE_LISTA';
            const listaAtual = JSON.parse(localStorage.getItem(chaveLs) || '[]');
            const idx = listaAtual.findIndex((i) => String(i.id) === String(idLocal));
            if (idx >= 0) {
              listaAtual[idx].enviado = 1;
              listaAtual[idx].apeenviado = 1;
              if (itemAtualizado.apeidnuvem || itemAtualizado.apeidapontamentonuvem) {
                listaAtual[idx].apeidnuvem = itemAtualizado.apeidnuvem || itemAtualizado.apeidapontamentonuvem;
                listaAtual[idx].apeidapontamentonuvem = itemAtualizado.apeidapontamentonuvem || itemAtualizado.apeidnuvem;
              }
              localStorage.setItem(chaveLs, JSON.stringify(listaAtual));
            }
          } catch (lsErr) {
            // ignore
          }

          errorHandler('Apontamento de embarque enviado com sucesso!');
        } else {
          errorHandler('Apontamento enviado com sucesso.');
        }
        await this.$_load();
      } catch (err) {
        console.error('Erro ao enviar apontamento de embarque para a nuvem:', err);
        errorHandler('Erro ao enviar apontamento de embarque para o servidor.');
      } finally {
        this.enviandoId = null;
      }
    },

    async $_load() {
      this.loading = true;
      try {
        const apontamentos = db.apontamentoembarque ? await db.apontamentoembarque.toArray() : [];
        const veiculos = db.veiculo ? await db.veiculo.toArray() : [];
        const pessoas = db.pessoa ? await db.pessoa.toArray() : [];
        const propriedades = db.propriedade ? await db.propriedade.toArray() : [];
        const produtos = db.produto ? await db.produto.toArray() : [];
        const talhoes = db.talhao ? await db.talhao.toArray() : [];

        const veiculosMap = new Map();
        veiculos.forEach((v) => {
          if (v.id != null) veiculosMap.set(String(v.id), v);
          if (v.veiidveiculo != null) veiculosMap.set(String(v.veiidveiculo), v);
          if (v.veiplaca) veiculosMap.set(v.veiplaca.trim().toUpperCase(), v);
        });

        const pessoasMap = new Map();
        pessoas.forEach((p) => {
          if (p.id != null) pessoasMap.set(String(p.id), p);
          if (p.pesidpessoa != null) pessoasMap.set(String(p.pesidpessoa), p);
        });

        const propriedadesMap = new Map();
        propriedades.forEach((pr) => {
          if (pr.id != null) propriedadesMap.set(String(pr.id), pr);
          if (pr.proidpropriedade != null) propriedadesMap.set(String(pr.proidpropriedade), pr);
        });

        const produtosMap = new Map();
        produtos.forEach((pd) => {
          if (pd.id != null) produtosMap.set(String(pd.id), pd);
          if (pd.proidproduto != null) produtosMap.set(String(pd.proidproduto), pd);
        });

        const talhoesMap = new Map();
        talhoes.forEach((t) => {
          if (t.id != null) talhoesMap.set(String(t.id), t);
          if (t.talidtalhao != null) talhoesMap.set(String(t.talidtalhao), t);
        });

        const listaCompleta = [...apontamentos];
        try {
          const listaLs = JSON.parse(localStorage.getItem('APONTAMENTOS_EMBARQUE_LISTA') || '[]');
          listaLs.forEach((itemLs) => {
            const jaExiste = listaCompleta.some((a) => String(a.id) === String(itemLs.id));
            if (!jaExiste) {
              listaCompleta.push(itemLs);
            }
          });
        } catch (e) {
          // ignore
        }

        const itensMapeados = listaCompleta
          .filter((a) => {
            const isDeletado = !!(a.apedeletar || a.deletar);
            const isEnviado = Number(a.enviado) === 1
              || Number(a.apeenviado) === 1
              || a.enviado === true
              || a.apeenviado === true;
            return !isDeletado && !isEnviado;
          })
          .sort((a, b) => new Date(b.apedata || b.dataHora || b.dataCriacao || 0) - new Date(a.apedata || a.dataHora || a.dataCriacao || 0))
          .map((a) => {
            const idLocal = a.id;
            const apeid = a.apeidapontamentoembarque || a.id;

            const vei = (a.apeidplaca != null ? veiculosMap.get(String(a.apeidplaca)) : null)
              || (a.apeplaca ? veiculosMap.get(String(a.apeplaca).trim().toUpperCase()) : null)
              || a.veiculoObj
              || null;
            const placa = a.apeplaca || vei?.veiplaca || a.placa || '';
            const frota = vei?.veifrota || a.frota || '';
            const marca = vei?.veimarca || a.marca || '';

            const pesMotorista = a.apeidmotorista != null ? pessoasMap.get(String(a.apeidmotorista)) : null;
            const motorista = a.apemotorista || pesMotorista?.pesnome || a.motorista || '';

            const pesProdutor = a.apeidprodutor != null ? pessoasMap.get(String(a.apeidprodutor)) : null;
            const produtor = a.apeprodutor || pesProdutor?.pesnome || a.produtor || '';

            const prop = a.apeidpropriedade != null ? propriedadesMap.get(String(a.apeidpropriedade)) : null;
            const propriedade = a.apepropriedade || prop?.pronome || a.propriedade || '';

            const prod = a.apeidproduto != null ? produtosMap.get(String(a.apeidproduto)) : null;
            const produtoNome = a.produto || a.apeproduto || prod?.prodescricaoFormatada || prod?.prodescricao || '';

            const tal = a.apeidtalhao != null ? talhoesMap.get(String(a.apeidtalhao)) : null;
            const talhaoNome = a.apetalhao || tal?.taldescricaoFormatada || tal?.taldescricao || a.talhao || '';

            const destino = a.apedestino || a.destino || '';
            const tipoMidia = a.apetipomidia || '';
            const observacao = a.apeobservacao || a.observacao || '';
            const dataHora = a.apedata || a.dataHora || a.dataCriacao || '';
            const sincronizado = !!(a.apeenviado || a.enviado || a.apedatanuvem || a.sincronizado);

            const localizacao = a.localizacao || (
              a.apelatitude != null && a.apelongitude != null
                ? { latitude: a.apelatitude, longitude: a.apelongitude }
                : null
            );

            const fotos = a.fotos || [];

            return {
              ...a,
              id: a.id,
              idLocal,
              apeidapontamentoembarque: apeid,
              apeidplaca: a.apeidplaca,
              apeplaca: placa,
              placa,
              frota,
              marca,
              veiculo: vei,
              apeidmotorista: a.apeidmotorista,
              apemotorista: motorista,
              motorista,
              apecontratomp: a.apecontratomp || a.contratoMp || '',
              contratoMp: a.apecontratomp || a.contratoMp || '',
              apeidprodutor: a.apeidprodutor,
              apeprodutor: produtor,
              produtor,
              apeidpropriedade: a.apeidpropriedade,
              apepropriedade: propriedade,
              propriedade,
              apeidproduto: a.apeidproduto,
              apeproduto: a.apeproduto || produtoNome,
              produto: produtoNome,
              apeidtalhao: a.apeidtalhao,
              apetalhao: talhaoNome,
              talhao: talhaoNome,
              apeiddestino: a.apeiddestino,
              apedestino: destino,
              destino,
              apetipomidia: tipoMidia,
              tipoMidia,
              apeobservacao: observacao,
              observacao,
              dataHora,
              apedata: dataHora,
              data: dataHora,
              apelatitude: a.apelatitude,
              apelongitude: a.apelongitude,
              localizacao,
              fotos,
              sincronizado,
            };
          });

        this.todosItens = itensMapeados;
        this.$_aplicarFiltros();
      } catch (err) {
        console.error('Erro ao carregar apontamentos de embarque do Dexie:', err);
        this.todosItens = [];
        this.itens = [];
      } finally {
        this.loading = false;
      }
    },

    $_aplicarFiltros() {
      const storageFrom = sessionStorage.getItem(APONTAMENTO_EMBARQUE_STORAGE.createdFrom)
        || sessionStorage.getItem(MANUTENCAO_STORAGE.createdFrom);
      const storageBefore = sessionStorage.getItem(APONTAMENTO_EMBARQUE_STORAGE.createdBefore)
        || sessionStorage.getItem(MANUTENCAO_STORAGE.createdBefore);
      const storagePlaca = sessionStorage.getItem(MANUTENCAO_STORAGE.placa);

      const createdFrom = getQueryValue(MANUTENCAO_QUERIES.createdFrom, storageFrom || null);
      const createdBefore = getQueryValue(MANUTENCAO_QUERIES.createdBefore, storageBefore || null);
      const placa = getQueryValue(MANUTENCAO_QUERIES.placa, storagePlaca || null);

      let filtrados = this.todosItens || [];

      const getDataStr = (d) => {
        if (!d) return '';
        const m = moment(d);
        return m.isValid() ? m.format('YYYY-MM-DD') : String(d).slice(0, 10);
      };

      if (createdFrom) {
        filtrados = filtrados.filter((item) => {
          const d = item.apedata || item.dataHora;
          if (!d) return false;
          return getDataStr(d) >= createdFrom;
        });
      }

      if (createdBefore) {
        filtrados = filtrados.filter((item) => {
          const d = item.apedata || item.dataHora;
          if (!d) return false;
          return getDataStr(d) <= createdBefore;
        });
      }

      if (placa && placa !== 'null' && placa !== 'undefined') {
        const pFiltro = String(placa).trim().toLowerCase();
        filtrados = filtrados.filter((item) => {
          const p = String(item.apeplaca || item.placa || (item.veiculo && item.veiculo.veiplaca) || '').toLowerCase();
          const f = String(item.frota || (item.veiculo && item.veiculo.veifrota) || '').toLowerCase();
          const m = String(item.marca || (item.veiculo && item.veiculo.veimarca) || '').toLowerCase();
          return p.includes(pFiltro) || f.includes(pFiltro) || m.includes(pFiltro);
        });
      }

      this.itens = filtrados;
    },

    $_limparFiltros() {
      const hoje = geraData(new Date(), 'YYYY-MM-DD');
      sessionStorage.setItem(MANUTENCAO_STORAGE.createdFrom, hoje);
      sessionStorage.setItem(MANUTENCAO_STORAGE.createdBefore, hoje);
      sessionStorage.setItem(APONTAMENTO_EMBARQUE_STORAGE.createdFrom, hoje);
      sessionStorage.setItem(APONTAMENTO_EMBARQUE_STORAGE.createdBefore, hoje);
      sessionStorage.removeItem(MANUTENCAO_STORAGE.placa);

      setQueryValue(MANUTENCAO_QUERIES.createdFrom, hoje);
      setQueryValue(MANUTENCAO_QUERIES.createdBefore, hoje);
      setQueryValue(MANUTENCAO_QUERIES.placa, null);
    },
  },

  watch: {
    $route: {
      deep: true,
      handler() {
        this.$_aplicarFiltros();
      },
    },
  },

  created() {
    const hoje = geraData(new Date(), 'YYYY-MM-DD');
    const storageFrom = sessionStorage.getItem(APONTAMENTO_EMBARQUE_STORAGE.createdFrom)
      || sessionStorage.getItem(MANUTENCAO_STORAGE.createdFrom);
    const storageBefore = sessionStorage.getItem(APONTAMENTO_EMBARQUE_STORAGE.createdBefore)
      || sessionStorage.getItem(MANUTENCAO_STORAGE.createdBefore);
    const storagePlaca = sessionStorage.getItem(MANUTENCAO_STORAGE.placa);

    const from = getQueryValue(MANUTENCAO_QUERIES.createdFrom, storageFrom || hoje);
    const before = getQueryValue(MANUTENCAO_QUERIES.createdBefore, storageBefore || hoje);
    const placa = getQueryValue(MANUTENCAO_QUERIES.placa, storagePlaca || null);

    setQueryValue(MANUTENCAO_QUERIES.createdFrom, from);
    setQueryValue(MANUTENCAO_QUERIES.createdBefore, before);
    if (placa && placa !== 'null' && placa !== 'undefined') {
      setQueryValue(MANUTENCAO_QUERIES.placa, placa);
    }

    this.$_load();
  },
};
</script>

<style scoped>
.wrapper {
  width: 100%;
  padding-bottom: 20px;
}

.divnovo {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  width: 100%;
  margin: -12px 0 0 0;
  z-index: 3;
  background-color: #eeeeee;
  padding: 12px 0 12px 0;
}

@media screen and (min-width: 960px) {
  .divnovo {
    top: 64px;
  }
}

.botaoinferior {
  color: white !important;
  font-weight: bold;
}

.sem-registro {
  text-align: center;
  padding: 100px 16px 40px 16px;
}

.cards-container {
  margin-top: 80px;
  padding: 0 12px;
}

.card-embarque {
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
  margin-bottom: 12px;
}

.card-header {
  padding: 12px 14px;
}

.item-id {
  font-size: 13px;
  color: #2e7d32;
}

.frota-titulo {
  font-size: 14px;
  color: #2c3e50;
}

.data-texto {
  font-size: 12px;
}

.card-detalhes {
  padding: 12px 14px;
  background-color: #fafafa;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 13px;
  padding: 4px 0;
}

.info-label {
  font-weight: 600;
  color: #616161;
  min-width: 130px;
}

.info-valor {
  color: #212121;
  text-align: right;
  word-break: break-word;
}

.info-obs {
  flex-direction: column;
  align-items: flex-start;
  margin-top: 4px;
}

.obs-box {
  text-align: left;
  margin-top: 4px;
  white-space: pre-wrap;
  color: #424242;
  background-color: #f0f0f0;
  padding: 6px 10px;
  border-radius: 4px;
  width: 100%;
  font-size: 12px;
}

.fotos-secao {
  width: 100%;
  border-top: 1px dashed #e0e0e0;
  padding-top: 8px;
}

.foto-miniatura-wrapper {
  cursor: pointer;
  transition: transform 0.15s ease-in-out;
}

.foto-miniatura-wrapper:hover {
  transform: scale(1.05);
}

.card-acoes {
  background-color: #ffffff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.btn-acao {
  height: 32px !important;
  font-size: 13px;
  border-radius: 6px;
}
</style>
